import React, { useState } from "react";
import { Button, Divider, InputNumber, Select, Space, message } from "antd";

export default function CustomComboBox({
  onChange,
  value,
  options = [],
  type = [],
  precision = 0,
}) {
  const [items, setItems] = useState(options);
  const [item, setItem] = useState({ value: null, unit: null, label: null });
  console.log(precision)
  return (
    <Select
      mode="tags"
      size="large"
      value={value}
      options={items}
      filterOption={(input, option) =>
        (option.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      onChange={onChange}
      dropdownRender={(menu) => (
        <div onMouseDown={(e) => e.stopPropagation()}>
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          <Space style={{ padding: "0 8px 4px" }}>
            <InputNumber
              style={{ width: "100%" }}
              onChange={(v) => {
                setItem((prev) => ({ ...prev, value: v.toString() }));
              }}
              precision={precision}
              size="large"
              min={0}
              value={item?.value}
              addonAfter={
                <Select
                  placeholder="Unit"
                  style={{ width: 100 }}
                  onChange={(v) => {
                    setItem((prev) => ({ ...prev, unit: v }));
                  }}
                  value={item?.unit}
                >
                  {type.length > 0 &&
                    type.map((t) => (
                      <Select.Option key={t} value={t}>
                        {t}
                      </Select.Option>
                    ))}
                </Select>
              }
            />
            <Button
              onClick={(e) => {
                e.preventDefault();

                const { value: val, unit } = item;

                if (val === null || val === undefined || !unit) {
                  message.warning("value and unit cannot be blank");
                  return;
                }

                if (items.some((i) => i.value === item.value)) {
                  message.error("value already exists");
                  return;
                }

                setItems([...items, { ...item, label: item.value + item.unit }]);

                setItem({ value: null, unit: null, label: null });
              }}
            >
              Add Item
            </Button>
          </Space>
        </div>
      )}
    />
  );
}
